import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import type { DepositResult } from '../../../../../../types/Cashier';
import Info from '../../../Info/Info';

import {
  TXTWCL_This_usually_takes_up_to_30_mi_ELL,
  TXTWCL_WeXll_send_you_an_email_update_ELL
} from './PartiallyCompletedCheck.messages.json';

type Props = DepositResult;

const PartiallyCompletedCheck: React.FC<Props> = ({ message }) => {
  const { defaultMessage: systemMsg } = message || { defaultMessage: '' };

  return (
    <Info>
      {systemMsg === '' ? (
        <>
          <Translation {...TXTWCL_This_usually_takes_up_to_30_mi_ELL} />{' '}
          <Translation {...TXTWCL_WeXll_send_you_an_email_update_ELL} />
        </>
      ) : (
        systemMsg
      )}
    </Info>
  );
};

export default PartiallyCompletedCheck;
